export default {
// id-ID.js
help: {
  faq: "FAQ",
  promo: "Promo",
  contactUs: "Hubungi Kami",
  joinCommunity: "Bergabung dengan Komunitas Kami",
  help: "Bantuan"
}
};
